
import {
    EmailSubsectionChip,
    IconBuildingTable,
    IconClockTable, IconDocumentLines, IconDocumentMedal,
    IconScheduleTable, IconShoppingCar, MobileIcon,
} from "../../../../../components/buttons/IconButtons";
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat, getFullName} from "../../../../../Apis/functions";

import CustomTooltip from "../../../../../components/CustomTooltip";
import {useTranslation} from "react-i18next";
import CustomCard from "../../../../../components/CustomCard";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import CustomChip from "../../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import OrderReceiverDetail from "./OrderReceiverDetail";
import {ORDER_SECTION} from "../../../Supplier/Model/Model";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const OrderData = ({ getOrderDetails, containerHeightRef, section }) => {
    const { t } = useTranslation();
    return (
        <CustomCard classes={'h-100'} classCard={'card-border-8px'} classContent={'p-0'}>
            <div className='d-flex flex-wrap  justify-content-between align-items-center m-3'>
                <CustomGenericTittleIconDataChip
                    title={'purchase_orders_details'}
                    Icon={IconDocumentLines}
                    border={false}
                    classNameTittleContainer={'justify-content-center'}
                    titleBoxClass={'d-flex'}
                />
                <CustomChip
                    className={"col-4"}
                    variant={'large'}
                    background={statusColor[getOrderDetails?.statusId]}
                    fontColor={statusFontColor[getOrderDetails?.statusId]}
                    borderColor={statusBorderColor[getOrderDetails?.statusId]}
                    legend={t(status[getOrderDetails?.statusId]) || EMPTY_VALUES.DEFAULT}
                />
            </div>

            <div className={'border-bottom-shades-300'} />

            <div className='row align-items-start p-3 overflow-y-auto' ref={containerHeightRef} >
                <div className='col-2 p-0'>
                    <div className='p-8px border-radius-8px d-flex w-44px h-44px justify-content-center background-secondary-100 mt-4'>
                        <IconDocumentMedal className='btn-icon-svg-24px' />
                    </div>
                </div>
                <div className='col-10'>
                    <div className='row my-4 px-0 ml-0 pl-0'>
                        <div className='pl-0 ml-0'>
                            <CustomTooltip
                                text={getOrderDetails?.folio?.toUpperCase() || EMPTY_VALUES.DEFAULT}
                                classes={`ffs-14px font-color-general-950 text-ellipsis-1-row ibl-font-w-600 pl-0 ml-0`}
                                showIfTruncated={true}
                            />
                        </div>
                        <div className='col-12 px-0'>
                            <div className='d-flex align-items-center'>
                                <IconBuildingTable />
                                <CustomTooltip
                                    text={getOrderDetails?.supplierCompanyAcronym}
                                    classes={'font-color-general-950 fs-14px ml-2'}
                                    showIfTruncated={true}
                                    placement={'top'}
                                />
                            </div>
                        </div>
                        <div className='border-bottom-shades-300 mt-3' />

                        <div className='col-12 px-0'>
                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 mt-3'>
                                {t('supplier_information')}
                            </p>
                            <div className={'flex-grow-1 minw-0'}>
                                <CustomTooltip
                                    text={getFullName(getOrderDetails?.supplierName,
                                        getOrderDetails?.supplierLastName,
                                        getOrderDetails?.supplierSecondLastName)}
                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row px-0`}
                                    showIfTruncated={true}
                                />
                            </div>
                            <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                <div className={'d-flex flex-grow-1 minw-0 align-items-center'}>
                                    <div className={'mr-2 d-flex align-items-center'}>
                                        <EmailSubsectionChip />
                                    </div>
                                    <div className={'flex-grow-1 minw-0'}>
                                        <CustomTooltip
                                            text={getOrderDetails?.supplierEmail}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row align-items-center`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                                <div className={'d-flex flex-grow-1 minw-0'}>
                                    <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                        <MobileIcon className='icon-color-shades-800 flex-shrink-0' />
                                    </div>
                                    <div className={'flex-grow-1 minw-0'}>
                                        <CustomTooltip
                                            text={getOrderDetails?.supplierPhoneNumber}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='border-bottom-shades-300 mt-3' />
                        <div className='col-12 px-0'>
                            <p className='font-color-general-950 fs-14px ibl-font-w-600 mt-3'>
                                {t('item')}
                            </p>
                            <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                <div className={'d-flex flex-grow-1 minw-0'}>
                                    <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                        <IconShoppingCar className='icon-color-shades-800 flex-shrink-0' />
                                    </div>
                                    <div className={'flex-grow-1 minw-0'}>
                                        <CustomTooltip
                                            text={getOrderDetails?.item}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='border-bottom-shades-300 mt-3'/>
                        <div className='col-12 px-0'>
                            <p className='font-color-general-950 fs-14px ibl-font-w-600 mt-3'>
                                {t('estimated_delivery_date')}
                            </p>
                            <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                <div className={'d-flex flex-grow-1 minw-0'}>
                                    <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                        <IconScheduleTable className='icon-color-shades-800 flex-shrink-0' />
                                    </div>
                                    <div className={'flex-grow-1 minw-0'}>
                                        <CustomTooltip
                                            text={getDateFormat(getOrderDetails?.deliveryDate,false, DATE_TIME_FORMAT_NAME_MODEL.dayWithShortMonth)}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        { getOrderDetails?.eta && section === ORDER_SECTION.DETAILS && <>
                                <div className='border-bottom-shades-300 mt-3'/>
                                <div className='col-12 px-0'>
                                    <p className='font-color-general-950 fs-14px ibl-font-w-600 mt-3'>
                                        {t('estimated_time_of_arrival')}
                                    </p>
                                    <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                        <div className={'d-flex flex-grow-1 minw-0'}>
                                            <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                <IconScheduleTable className='icon-color-shades-800 flex-shrink-0' />
                                            </div>
                                            <div className={'flex-grow-1 minw-0'}>
                                                <CustomTooltip
                                                    text={getDateFormat(getOrderDetails?.eta,false, DATE_TIME_FORMAT_NAME_MODEL.dayWithShortMonth)}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                        <div className={'d-flex flex-grow-1 minw-0'}>
                                            <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                <IconClockTable className='icon-color-shades-800 flex-shrink-0' />
                                            </div>
                                            <div className={'flex-grow-1 minw-0'}>
                                                <CustomTooltip
                                                    text={getDateFormat(getOrderDetails?.eta,false, DATE_TIME_FORMAT_NAME_MODEL.time12Uppercase)}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }


                        <div className='border-bottom-shades-300 mt-3'/>
                        <div className='col-12 px-0 gap-2 mt-3'>
                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>
                                {t('order_description')}
                            </p>
                            <p className='font-color-general-950 fs-14px px-0'>
                                {getOrderDetails?.description || EMPTY_VALUES.DEFAULT}
                            </p>
                        </div>

                        { getOrderDetails?.actualDeliveryDate &&
                            <>
                                <div className='border-bottom-shades-300 mt-3'/>
                                <OrderReceiverDetail
                                    getOrderDetails={getOrderDetails}
                                />
                            </>
                        }

                    </div>
                </div>
            </div>

        </CustomCard>
    );
};

export default OrderData;
